var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGif = function SvgGif(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M6 2a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6H6Zm1.933 14.033c1.88 0 3.082-1.167 3.082-2.988v-.88H8.09v.963h1.69l-.006.146c-.014 1.001-.747 1.67-1.821 1.67-1.255 0-2.046-1-2.046-2.617v-.01c0-1.592.776-2.593 2.007-2.593.903 0 1.548.45 1.777 1.221l.015.049h1.25l-.005-.049c-.24-1.377-1.411-2.31-3.037-2.31-2.007 0-3.291 1.44-3.291 3.692v.01c0 2.275 1.27 3.696 3.31 3.696Zm4.272-.176h1.26V8.811h-1.26v7.046Zm3.984 0h-1.26V8.811h4.492v1.06h-3.232v2.085h2.954v1.025h-2.954v2.876Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGif);
export default ForwardRef;